import { render, staticRenderFns } from "./ImpersonateAction.vue?vue&type=template&id=6b7b38f8"
import script from "./ImpersonateAction.vue?vue&type=script&lang=js"
export * from "./ImpersonateAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports